module.exports = "/_next/static/images/background-65beecd1505a28156096be9788a07842.jpg";